import moment from 'moment';

export class Periodo {
  anio: number;
  mes: number;

  static getPeriodoActual(): Periodo {
    return new Periodo(null, null);
  }

  static isPeriodoActual(periodo: Periodo): boolean {
    return periodo.anio === 0 && periodo.mes === 0;
  }

  static fromDate(date: Date): Periodo {
    return new Periodo(date.getMonth() + 1, date.getFullYear());
  }

  static fromMoment(m: moment.Moment) {
    return new Periodo(m.month() + 1, m.year());
  }

  constructor(mes: any, anio: any) {
    this.mes = +mes;
    this.anio = +anio;
  }

  equals(periodo: Periodo): boolean {
    return this.mes === periodo?.mes && this.anio === periodo?.anio;
  }

  isValid(): boolean {
    if (isNaN(this.anio) || isNaN(this.mes)) {
      return false;
    }
    if (!this.mes || !this.anio) {
      return false;
    }
    if (this.mes < 1 || this.mes > 12) {
      return false;
    }
    return true;
  }

  isCurrentPeriod(): boolean {
    const date = new Date();
    return (
      (this.anio === 0 && this.mes === 0) ||
      (this.anio === date.getFullYear() && this.mes === date.getMonth() + 1)
    );
  }
}
